import { useState } from 'react'
import { normalizeZipInput, useZipLocation } from '../lib/useZipLocation'
import { useNavigate } from 'react-router-dom'
import api from '../lib/api'

export default function PlaceNewPage() {
  const navigate = useNavigate()
  const [placeType, setPlaceType] = useState('OTHER')
  const [name, setName] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [zip, setZip] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const zipLookup = useZipLocation({ zip, onCity: setCity, onState: setState, lookupZip: api.geo.zipLookup })

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setSaving(true)
    try {
      const res = await api.places.create({ placeType, name, city, state, zip })
      navigate(`/places/${res.data.place.id}`)
    } catch (err: any) {
      setError(err?.response?.data?.error ?? 'Failed to create place')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="max-w-3xl mx-auto p-6 space-y-4">
      <h1 className="text-2xl font-bold">New Place</h1>
      {error && <div className="border border-red-200 bg-red-50 text-red-700 px-3 py-2 rounded text-sm">{error}</div>}
      <form className="bg-white border rounded-xl p-4 grid grid-cols-1 md:grid-cols-2 gap-3" onSubmit={submit}>
        <select className="border rounded px-3 py-2 text-sm" value={placeType} onChange={(e) => setPlaceType(e.target.value)}>
          <option value="PICKUP">PICKUP</option>
          <option value="DELIVERY">DELIVERY</option>
          <option value="TERMINAL">TERMINAL</option>
          <option value="OTHER">OTHER</option>
        </select>
        <input className="border rounded px-3 py-2 text-sm" value={name} onChange={(e) => setName(e.target.value)} placeholder="Place name" />
        <input className="border rounded px-3 py-2 text-sm" value={city} onChange={(e) => setCity(e.target.value)} placeholder="City" />
        <input className="border rounded px-3 py-2 text-sm" value={state} onChange={(e) => setState(e.target.value)} placeholder="State" />
        <input className="border rounded px-3 py-2 text-sm" value={zip} onChange={(e) => setZip(normalizeZipInput(e.target.value))} placeholder="ZIP" maxLength={10} inputMode="numeric" />
        {(zipLookup.loading || zipLookup.message) && <p className="text-xs text-slate-500" role="status">{zipLookup.loading ? 'Looking up ZIP...' : zipLookup.message}</p>}
        <div className="md:col-span-2 flex gap-2">
          <button disabled={saving} className="bg-blue-700 text-white px-4 py-2 rounded text-sm">{saving ? 'Saving...' : 'Create'}</button>
          <button type="button" onClick={() => navigate('/places')} className="border px-4 py-2 rounded text-sm">Cancel</button>
        </div>
      </form>
    </div>
  )
}
